import { Component, Input } from "@angular/core";
import { TagData } from "globals/store/tags.data";
import { EntityName } from 'globals/store/entity.data';
import { PhotoComponent } from "src/app/components/photo";
import { IconComponent } from "src/app/components/icon/icon.component";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'tiny-tags',
    template: `
<icon class="titleIcon" *ngIf="titleIcon" [icon]="titleIcon"></icon>
<div class="tags">
  <div class="tag" *ngFor="let tag of tags">
    <photo *ngIf="tag.photoURL" [data]="tag" [size]="16"></photo>
    <div class="name">{{ tag.title || 'Unnamed ' + entityName }}</div>
  </div>
</div>
`,
    styleUrls: [`tiny-tags.scss`],
    standalone: true,
    imports: [PhotoComponent, IconComponent, CommonModule],
})
export class TinyTagsComponent {
  @Input() titleIcon: string
  @Input() entityName: EntityName | 'Worker'
  @Input() tags: TagData[]
}

